import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { CRMUnreadIndicatorsContext } from "./CRMUnreadIndicatorsContext";

export const useCRMUnreadIndicators = () => {
  const context = useContext(CRMUnreadIndicatorsContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useCRMUnreadIndicators",
      "CRMUnreadIndicatorsContext"
    );
  }

  return context;
};
